import { LoggerFactory, getLoggerHierarchyFor } from "../impl/LoggerFactory";
import { ICoreLogger } from "../api/ICoreLogger";
import { LoggingLevel } from "../api/LoggingLevel";
import { IContext } from "js-logger";
import { Loggers, LoggerConfigurator } from "../../../../../index";

const factory = new LoggerFactory(Loggers);

export function getLogger(value?: string): ICoreLogger {
    // TODO @HTML5 maybe we can get rid of the factory and just keep the map here
    return factory.getLoggerFor(value);
}

export function setLoggerFormatter(formatter: (messages: any[], context: IContext) => void): void {
    LoggerConfigurator.setFormatter(formatter);
}

export function cascadeLogLevelFor(name: string, level: LoggingLevel): void {
    const hierarchy = getLoggerHierarchyFor(name);

    hierarchy.forEach((logger: ICoreLogger) => {
        logger.setLevel(level)
    });
}